<template>
<form
  :method="methodType"
  accept-charset="UTF-8"
  autocomplete="off"
  :action="this.apiUrl(actionUrl, true)"
  id="partner-app-form"
  :reset="true"
  v-on:submit.prevent="submit"
>

  <div class="form-group">
    <label for="partner_app_name">
      Partner App Name
    </label>

    <input
      type="text"
      name="partner_app[name]"
      id="parnter_name"
      class="form-control"
      v-model="name"
    />
  </div>

  <div class="form-group">
    <label for="partner_app_slug">
      Partner App Slug
    </label>

    <input
      type="text"
      name="partner_app[slug]"
      id="parnter_slug"
      class="form-control"
      v-model="slug"
    />
  </div>

  <div class="form-group">
    <label for="partner_app_description">
      Partner App Description
    </label>

    <textarea
      type="text"
      name="partner_app[description]"
      id="parnter_description"
      class="form-control"
      v-model="description"
    ></textarea>
  </div>

  <div class="form-group row">
    <div class="col">
      <label for="partner_app_inactive">
        <input type="hidden" name="partner_app[inactive]" value="false" />
        <input
          type="checkbox"
          name="partner_app[inactive]"
          id="partner_app_inactive"
          v-model="inactive"
        />

        Inactive?
      </label>
    </div>
  </div>

  <button
    class="form-control btn btn-primary"
    type="submit"
  >
    {{ actionLbl }} Partner App
  </button>

  <div
    id="partner-app-destructive-options"
    v-if="partnerAppId"
  >
    <hr />

    <button
      class="form-control btn btn-danger"
      v-on:click.prevent="resetApiToken"
      v-if="id"
    >
       Reset Partner App API Token
    </button>

    <hr />

    <button
      class="form-control btn btn-danger"
      v-on:click.prevent="destroy"
      v-if="id"
    >
       Delete Partner App
    </button>
  </div>
</form>

</template>

<script>
import FlashStore from '@/stores/FlashStore'
import PartnerAppStore from '@/stores/PartnerAppStore'

export default {
  data () {
    return PartnerAppStore.state
  },

  computed: {
    actionLbl () {
      return this.partnerAppId ? 'Edit' : 'Create'
    },

    actionUrl () {
      return '/partners/' + this.partnerId + '/partner_apps/' + (this.partnerAppId ? this.partnerAppId : '')
    },

    methodType () {
      return this.partnerAppId ? 'PUT' : 'POST'
    }

  },

  props: [
    'partnerId', 'partnerAppId'
  ],

  created () {
    if (this.partnerAppId) {
      this.get()
    }
  },

  methods: {
    get () {
      this.apiGet(this.actionUrl, PartnerAppStore, true).then((resp) => {
        this.apps = resp.relationships.apps
      })
    },

    destroy () {
      if (confirm(
        'Are you sure you want to delete this Partner App?'
      )) {
        if (confirm(
          'Are you absolutely sure? You cannot undo Partner App deletion.'
        )) {
          this.$http.delete(
            this.apiUrl(this.actionUrl, true)
          ).then((resp) => {
            this.$router.push({
              name: 'partner',
              params: {
                'partnerId': this.partnerId
              }
            })

            FlashStore.result('Partner app deleted.')
          }, this.processErrors)
        }
      }
    },

    resetApiToken () {
      if (confirm(
        'Are you sure you want to regenerate this Partner App API token? ' +
        'This partner will no longer be able access the service ' +
        'until they update it with the new token.'
      )) {
        if (confirm(
          'Are you absolutely sure? You cannot undo Partner App API token regeneration.'
        )) {
          this.$http.post(
            this.apiUrl(
              '/partners/' + this.partnerId + '/regenerate_api_token/' + this.partnerAppId, true
            )
          ).then((resp) => {
            this.processSuccess(resp)

            this.$router.push({
              name: 'partner_app',
              params: {
                'partnerId': this.partnerId,
                'partnerAppId': this.partnerAppId
              }
            })

            FlashStore.result('API token regenerated.')
          }, this.processErrors)
        }
      }
    },

    submit (ev) {
      this.bindSubmit(ev).then((resp) => {
        const partnerApp = this.processSuccess(resp)

        this.$router.push({
          name: 'partner_app',
          params: {
            'partnerId': partnerApp.partner.id,
            'partnerAppId': partnerApp.id
          }
        })
      }, this.processErrors)
    },

    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/PartnerAppForm.vue